(() => {
  'use strict';
  const banner = document.querySelector('[data-cookie-banner]');
  const key = 'nutrafol-consent';
  const read = () => { try { return localStorage.getItem(key); } catch { return null; } };
  const syncGoogleConsent = (privacy = window.Shopify?.customerPrivacy) => {
    if (typeof window.gtag !== 'function') return;
    const allowed = method => typeof privacy?.[method] === 'function' ? privacy[method]() === true : read() === 'all';
    const marketing = allowed('marketingAllowed');
    const sharing = marketing && allowed('saleOfDataAllowed');
    window.gtag('consent', 'update', {
      ad_storage: marketing ? 'granted' : 'denied',
      analytics_storage: allowed('analyticsProcessingAllowed') ? 'granted' : 'denied',
      ad_user_data: sharing ? 'granted' : 'denied',
      ad_personalization: sharing ? 'granted' : 'denied'
    });
  };
  const nativeBanner = () => document.querySelector('#shopify-pc__banner, #shopify-pc__prefs');
  const hide = () => { if (banner) banner.hidden = true; };
  const sync = () => {
    // Shopify's store-level banner owns consent when enabled. Never layer
    // a second set of buttons over it or reopen the fallback after dismissal.
    if (nativeBanner() || read()) return hide();
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.currentVisitorConsent) {
      const consent = privacy.currentVisitorConsent();
      if (Object.values(consent).some(value => value === 'yes' || value === 'no')) return hide();
    }
    if (banner) banner.hidden = false;
  };
  const withPrivacy = callback => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) return callback(window.Shopify.customerPrivacy);
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => callback(error ? null : window.Shopify.customerPrivacy));
    } else callback(null);
  };
  function save(value) {
    // Dismiss immediately even when Shopify's API is slow or unavailable.
    try { localStorage.setItem(key, value); } catch {}
    hide(); document.querySelector('#content-dialog')?.close();
    const all = value === 'all';
    withPrivacy(privacy => {
      if (privacy) privacy.setTrackingConsent({analytics:all,marketing:all,preferences:all,sale_of_data:all}, () => syncGoogleConsent(privacy));
      else syncGoogleConsent(null);
    });
    const status = document.querySelector('#live-announcement');
    if (status) status.textContent = 'Cookie preferences saved.';
  }
  document.addEventListener('click', event => {
    const consent = event.target.closest('[data-consent], [data-consent-choice]');
    if (consent) { event.preventDefault(); save(consent.dataset.consent || consent.dataset.consentChoice); return; }
    if (!event.target.closest('[data-cookie-settings]')) return;
    event.preventDefault();
    if (window.privacyBanner?.showPreferences) { hide(); window.privacyBanner.showPreferences(); return; }
    const modal = document.querySelector('#content-dialog');
    if (!modal) return;
    document.querySelector('#content-title').textContent = 'Cookie preferences';
    document.querySelector('[data-dialog-content]').innerHTML = '<p>Essential cookies keep your shopping bag and secure checkout working. Choose whether to allow optional cookies for preferences, analytics and marketing.</p><div class="nf-cookie-choices"><button type="button" class="nf-secondary" data-consent-choice="essential">Essential only</button><button type="button" class="nf-primary" data-consent-choice="all">Allow optional cookies</button></div>';
    if (!modal.open) modal.showModal();
  });
  document.addEventListener('visitorConsentCollected', () => { hide(); syncGoogleConsent(); });
  const observer = new MutationObserver(sync);
  observer.observe(document.body, {childList:true,subtree:true});
  withPrivacy(privacy => { sync(); syncGoogleConsent(privacy); }); sync();
})();
